import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { FormBuilder, FormGroup } from '@angular/forms'
import { createAutomationIncidentDataForm } from '@tv3/containers/automations/automation-data-form/incident/form/automation-incident-data-form.component'
import { SaveForm } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-automation-incident-data-dialog',
  templateUrl: './automation-incident-data-dialog.component.html',
  styleUrls: ['./automation-incident-data-dialog.component.scss'],
  host: { class: 'modal-content' },
})
export class AutomationIncidentDataDialogComponent implements OnInit {
  form = createAutomationIncidentDataForm(this.fb, !this.data?.hideReporterField)

  constructor(
    public dialogRef: MatDialogRef<AutomationIncidentDataDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { data: any; hideReporterField?: boolean }
  ) {
    this.form.patchValue(this.data.data)
  }

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  onSave(form: FormGroup) {
    this.dialogRef.close(form.getRawValue())
  }
}
